import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import SchemaForm from 'app/components/general/SchemaForm';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';

import SectionGroup from 'app/components/general/SectionGroup';

import * as invitationsActions from 'app/ducks/invitations/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as invitationsSelectiors from 'app/ducks/invitations/selectors';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    invitations: invitationsSelectiors.getInvitations(state),
  };
}

const actionCreators = _.merge(invitationsActions);

interface IProps {
  appReady: boolean;
  teamManager: any;
  team: any;
  invitations: any;
  actions: any;
  errors: any;
  match: any;
  afterSubmit: Function;
}

interface IFormState {
  fullName?: string;
  email?: string;
  mobile?: string;
}

const formSchema = {
  required: ['fullName', 'email', 'mobile'],
  properties: {
    fullName: {
      type: 'string',
      title: 'Full Name',
    },
    email: {
      type: 'string',
      title: 'Email',
    },
    mobile: {
      type: 'string',
      inputType: 'phone',
      title: 'Mobile',
    },
  },
};

const uiSchema = {
  fullName: { classNames: 'col' },
  mobile: { 'ui:field': 'phone' },
};

const JoinTeam: FC<IProps> = (props: IProps = {
  appReady: false,
  invitations: undefined,
  teamManager: undefined,
  team: undefined,
  actions: undefined,
  errors: undefined,
  match: undefined,
  afterSubmit: undefined,
}) => {
  const [originalFormData, setOriginalFormData] = useState<IFormState>({});
  const [formData, setFormData] = useState<IFormState>({});
  const [changed, setChanged] = useState(false);
  const [saved, setSaved] = useState(false);
  const [reset, setReset] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e): void => {
    const checkChanged = originalFormData !== e.formData;
    setFormData(e.formData);
    setErrors({});
    setReset(false);
    setChanged(checkChanged);
  };
  const isValid = (): boolean => _.isEmpty(errors) && changed;

  const handleError = (newErrors): void => {
    setErrors(newErrors);
  };

  const handleSubmit = (data, e): void => {
    if (isValid()) {
      props.actions.createEnrolment({
        invitation: {
          id: props.invitations.currentInvitation?.id,
        },
        team: {
          id: props.invitations.currentInvitation?.teamId,
        },
        user: {
          id: props.invitations.currentInvitation?.userId,
        },
        fullName: formData.fullName,
        email: formData.email,
        mobile: formData.mobile,
        inviteToken: props.invitations.currentInvitation?.inviteToken,
      },
      (teamMemberCode: string) => {
        history.push(`${props.match.params.teamCode}/${teamMemberCode}`);
      });
    }
    setChanged(false);
  };

  return (
    <SectionGroup title="Join Team">
      <div className="row">
        <div className="col col-md-8 col-lg-6">
          <div className="form-description">
            Your team manager
            {' '}
            <span className="text-weight-medium-bold">{props.teamManager?.firstName}</span>
            {' '}
            is using Teammo to request, pay, and track payments for your team
            {' '}
            <span className="text-weight-medium-bold">{props.team?.name}</span>
            .
            <br />
            <br />
            Provide your details below and you will be able to contribute towards your team fees, view your payment history and see your teams activity.
          </div>
        </div>
      </div>
      <div className="row with-margin-top">
        <div className="col col-md-8 col-lg-6">
          <SchemaForm
            uiSchema={uiSchema}
            schema={formSchema}
            handleChange={handleChange}
            handleError={handleError}
            handleSubmit={handleSubmit}
            formData={formData}
            isValid={isValid()}
            showAddAnotherButton={false}
            isLoading={props.invitations.isSaving}
            hasSaved={props.invitations.hasSaved}
            hasFailed={props.invitations.hasFailed}
            originalFormData={originalFormData}
          />
        </div>
      </div>
      <div className="row with-margin-top">
        <div className="col col-md-8 col-lg-6">
          What is Teammo?
          {' '}
          <Link to="https://teammo.com.au" target="_blank">Learn more</Link>
        </div>
      </div>
    </SectionGroup>
  );
};

export default connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))(JoinTeam);
